// DashboardXL utils - Sprint 44 Fase 3 Vista 1.
// Formatters especificos del dashboard (compactos K/M/B + fechas cortas)
// y algoritmo de escala "nice" para ejes. Los formatters monetarios
// generales viven en src/utils/money.js y se reusan desde ahi
// (fmtMoney / fmtNumber). No duplicamos logica.

/**
 * Formato compacto: 1.250.000 -> "1,3M", 45000 -> "45K", -3500 -> "-3,5K".
 * Usa coma como separador decimal (es-CO). No lleva moneda.
 */
export function fmtCopCompact(value) {
  if (value === null || value === undefined || value === '') return '\u2014';
  const n = Number(value);
  if (Number.isNaN(n)) return '\u2014';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  const oneDec = (x) => x.toFixed(1).replace(/\.0$/, '').replace('.', ',');
  if (abs >= 1_000_000_000) return sign + oneDec(abs / 1_000_000_000) + 'B';
  if (abs >= 1_000_000)     return sign + oneDec(abs / 1_000_000)     + 'M';
  if (abs >= 1_000)         return sign + oneDec(abs / 1_000)         + 'K';
  return sign + Math.round(abs).toString();
}

/**
 * Entero con separador de miles es-CO. 1234 -> "1.234".
 */
export function fmtInt(value) {
  if (value === null || value === undefined || value === '') return '\u2014';
  const n = Number(value);
  if (Number.isNaN(n)) return '\u2014';
  return n.toLocaleString('es-CO');
}

/**
 * Fecha ISO "YYYY-MM-DD" -> "DD/MM". Sin ano (para ejes X compactos).
 */
export function fmtFechaCorta(iso) {
  if (!iso) return '';
  const parts = String(iso).split('-');
  if (parts.length < 3) return String(iso);
  const [, m, d] = parts;
  return d + '/' + m;
}

/**
 * Algoritmo "nice scale": dado un max de datos y un numero de ticks deseado,
 * calcula el max redondeado y los ticks. Mismo criterio que el dashboard
 * legacy pero modernizado (const/let, explicit steps).
 *
 * Returns: { max: number, ticks: number[] }.
 */
export function niceScale(dataMax, targetTicks = 6) {
  const tt = Number(targetTicks) > 0 ? Number(targetTicks) : 6;
  if (!dataMax || dataMax <= 0) {
    return { max: 1, ticks: [0, 0.2, 0.4, 0.6, 0.8, 1] };
  }
  const rawStep = dataMax / tt;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const normalized = rawStep / magnitude;

  let niceStep;
  if (normalized <= 1)        niceStep = 1;
  else if (normalized <= 2)   niceStep = 2;
  else if (normalized <= 2.5) niceStep = 2.5;
  else if (normalized <= 5)   niceStep = 5;
  else                        niceStep = 10;

  const step = niceStep * magnitude;
  const niceMax = Math.ceil(dataMax / step) * step;
  const ticks = [];
  for (let v = 0; v <= niceMax + step / 2; v += step) {
    ticks.push(Number(v.toFixed(10)));
  }
  return { max: niceMax, ticks };
}
